import CoursePathForm from '@/components/admin/courses/CoursePathForm';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import InfoSideModal from '@/components/ui/custom/InfoSideModal';
import useToggle from '@/data/hook/useToggle';
import CoursePath from '@/models/CoursePath';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

type InformationActionProps = {
  coursePath: CoursePath;
};

export default function InformationAction({
  coursePath,
}: InformationActionProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseBox.actions',
  });

  const { isOpen, open, close } = useToggle();

  const modalTrigger = (
    <MainButton
      text={t('legalInformation')}
      color="custom"
      onClick={open}
      className="font-500 !text-14 text-primary gap-0.5 flex-row-reverse w-fit"
      icon={
        <InformationCircleIcon
          className={'w-4 h-4 ease-in-out transition-all duration-200'}
          strokeWidth={3}
        />
      }
    />
  );

  return (
    <InfoSideModal
      trigger={modalTrigger}
      open={isOpen}
      className={{
        reference: 'w-fit flex justify-end',
      }}
      onClose={close}
      title={coursePath.course.name}
      subtitle={t('legalInformation')}
    >
      <div className="flex flex-col gap-2.5 grow">
        <CoursePathForm course={coursePath} />
      </div>
    </InfoSideModal>
  );
}
